import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=15998ec2&scoped=true"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=15998ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15998ec2",
  null
  
)

export default component.exports